/**
 * BusinessUnit CRUD
 */

import type { BusinessUnit } from '../../graphql/types';
import { createEntityCrudClient } from './crudFactory';

export interface CreateBusinessUnitInput {
  name: string;
  description?: string;
  unitType: string;
  lifecycleStatus?: string;
  parentBusinessUnitId?: string;
  code?: string;
  tags?: string[];
}

export interface UpdateBusinessUnitInput {
  name?: string;
  description?: string;
  unitType?: string;
  lifecycleStatus?: string;
  parentBusinessUnitId?: string;
  code?: string;
  tags?: string[];
}

const client = createEntityCrudClient<
  BusinessUnit,
  CreateBusinessUnitInput,
  UpdateBusinessUnitInput
>('/business-units');

export async function createBusinessUnit(input: CreateBusinessUnitInput): Promise<BusinessUnit> {
  return client.create(input);
}

export async function updateBusinessUnit(
  businessUnitId: string,
  input: UpdateBusinessUnitInput
): Promise<BusinessUnit> {
  return client.update(businessUnitId, input);
}

export async function deleteBusinessUnit(
  businessUnitId: string,
  hardDelete: boolean = false
): Promise<void> {
  return client.remove(businessUnitId, hardDelete);
}
